<script lang="ts">
  import StickyBottom from "./StickyBottom.svelte";

  export let sticky: boolean = true;
</script>

<div class="form-actions">
  {#if sticky}
    <StickyBottom>
      <div class="actions-layout">
        <slot />
      </div>
    </StickyBottom>
  {:else}
    <div class="actions-layout mb1">
      <slot />
    </div>
  {/if}
</div>

<style lang="scss">
  .form-actions {
    margin-top: 1.2rem;
  }

  .actions-layout {
    display: flex;
    justify-content: flex-end;
    gap: 1.2rem;
  }

  .mb1 {
    margin-bottom: 1.2rem;
  }
</style>
